<form [formGroup]="threadGroupForm">
    <div class="row">
        <div class="col-4">
            <label for=""> Target Rate (RPM)<small class="text-danger">*</small> : </label>
            <input class="form-control form-control-sm" type="number" min="1" formControlName="targetRate"
                (change)="updateConcurrencyUserLimit($event)" />
        </div>
        <div class="col-4">
            <label for="">Ramp-Up Time (min)<small class="text-danger">*</small> : </label>
            <input class="form-control form-control-sm" type="number" min="0" formControlName="rampUpTime" (change)="updateRampUpTime($event)"/>
        </div>
        <div class="col-4">
            <label for=""> Duration (min)<small class="text-danger">*</small> : </label>
            <input class="form-control form-control-sm" type="number" min="1" formControlName="holdTargetRateTime" />
        </div>
    </div>
    <label class="clickable mt-2 mb-2" (click)="showAdvancedOptions = !showAdvancedOptions">
        <i class="fas fa-caret-right clickable collapse-icon" *ngIf="!showAdvancedOptions"></i>
        <i class="fas fa-caret-down clickable collapse-icon" *ngIf="showAdvancedOptions"></i>
        Advanced Setting
    </label>
    <div class="row" *ngIf="showAdvancedOptions">
        <div class="col-4">
            <label for=""> Ramp-Up Steps Count: </label>
            <input class="form-control form-control-sm" type="number" min="0" formControlName="rampUpStepsCount" />
        </div>
        <div class="col-4">
            <label for=""> Concurrency User Limit : </label>
            <input class="form-control form-control-sm" type="number" min="1" formControlName="concurrencyUserLimit" />
        </div>
    </div>
</form>
<div class="modal-footer" style="border-top: none;">
    <button type="submit" class="btn btn-primary btn-sm" (click)="saveConfiguration()" *ngIf="!edited"
        [disabled]="threadGroupForm.invalid"> Add Configuration </button>
    <button type="submit" class="btn btn-primary btn-sm" (click)="updateConfiguration()" *ngIf="edited"
        [disabled]="threadGroupForm.invalid"> Update Configuration </button>
    <button class="btn btn-warning btn-sm" type="button" (click)="cancelThreadGroupCreation()">Cancel</button>
</div>